module.exports = __webpack_public_path__ + "media/site_templates/www.hirelocalplumbers.com.au/images/feature_2-4b8d57e1f7773d3cab71bb7451ee40e8.jpeg";